var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderImg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 277 300",
    width: 277,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "31999381_2208_w026_n002_2326b_p1_2326-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 14.1,
    y1: 78.1,
    x2: 42.2,
    y2: 10.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbfe6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 114.9,
    y1: 245.5,
    x2: 114.9,
    y2: 252.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e522d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2443"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 117.1,
    y1: 134,
    x2: 117.1,
    y2: 171.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbfe6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 159.1,
    y1: 188.7,
    x2: 159.1,
    y2: 248.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc3c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc9de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 178.1,
    y1: 152.8,
    x2: 178.1,
    y2: 211.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd7da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff0e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 180.6,
    y1: 60.4,
    x2: 184.9,
    y2: 155.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd7da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 149.5,
    y1: 69.9,
    x2: 152.2,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d91a81"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g8",
    cx: 148,
    cy: 135.4,
    r: 77.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc16b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9517a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a1a88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 175.1,
    y1: 154.1,
    x2: 93.8,
    y2: 157.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d91a81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 135.5,
    y1: 66.4,
    x2: 136.9,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd7da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 130.5,
    y1: 71.6,
    x2: 131.7,
    y2: 97.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d91a81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 197.5,
    y1: 188.1,
    x2: 197.5,
    y2: 252.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd7da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff0e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 194.1,
    y1: 155.8,
    x2: 194.1,
    y2: 210.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd7da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 178.7,
    y1: 152,
    x2: 178.7,
    y2: 183.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#931a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae04b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 147.3,
    y1: 152.2,
    x2: 147.3,
    y2: 179.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#931a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae04b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 158.9,
    y1: 184.4,
    x2: 158.9,
    y2: 216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#931a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae04b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: 140.3,
    y1: 186.5,
    x2: 140.3,
    y2: 216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#931a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae04b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g18",
    x1: 185.4,
    y1: 185.8,
    x2: 185.4,
    y2: 210.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e522d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x1: 107.6,
    y1: 134,
    x2: 107.6,
    y2: 162.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e522d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x1: 119.6,
    y1: 157.9,
    x2: 129.8,
    y2: 159.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e522d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2443"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g21",
    x1: 165.7,
    y1: 247.6,
    x2: 165.7,
    y2: 253.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e522d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2443"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 133.9,
    y1: 240.9,
    x2: 104.3,
    y2: 240.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e522d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g23",
    x1: 178.4,
    y1: 243.7,
    x2: 146.9,
    y2: 243.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e522d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g24",
    x1: 137.8,
    y1: 235.7,
    x2: 130.6,
    y2: 213.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#931a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae04b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g25",
    x1: 133.7,
    y1: 233.6,
    x2: 127.7,
    y2: 214.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e522d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2483"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g26",
    x1: 121.6,
    y1: 198.5,
    x2: 131.6,
    y2: 213.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#931a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae04b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g27",
    x1: 119.6,
    y1: 199.9,
    x2: 128.3,
    y2: 213.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e522d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2483"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #aaefff } \n\t\t.s1 { fill: url(#g1) } \n\t\t.s2 { opacity: .3;mix-blend-mode: multiply;fill: #ab2781 } \n\t\t.s3 { fill: url(#g2) } \n\t\t.s4 { fill: url(#g3) } \n\t\t.s5 { fill: url(#g4) } \n\t\t.s6 { fill: url(#g5) } \n\t\t.s7 { fill: url(#g6) } \n\t\t.s8 { opacity: .5;mix-blend-mode: multiply;fill: #ab2781 } \n\t\t.s9 { opacity: .5;mix-blend-mode: multiply;fill: url(#g7) } \n\t\t.s10 { fill: url(#g8) } \n\t\t.s11 { opacity: .5;mix-blend-mode: multiply;fill: url(#g9) } \n\t\t.s12 { fill: url(#g10) } \n\t\t.s13 { fill: #3bc7c2 } \n\t\t.s14 { fill: #3bffc2 } \n\t\t.s15 { opacity: .5;mix-blend-mode: multiply;fill: url(#g11) } \n\t\t.s16 { fill: #ffffff } \n\t\t.s17 { opacity: .5;mix-blend-mode: soft-light;fill: #ffffff } \n\t\t.s18 { opacity: .3;mix-blend-mode: multiply;fill: #e767a7 } \n\t\t.s19 { mix-blend-mode: soft-light;fill: #ffffff } \n\t\t.s20 { fill: url(#g12) } \n\t\t.s21 { fill: url(#g13) } \n\t\t.s22 { fill: url(#g14) } \n\t\t.s23 { fill: url(#g15) } \n\t\t.s24 { fill: url(#g16) } \n\t\t.s25 { fill: url(#g17) } \n\t\t.s26 { fill: url(#g18) } \n\t\t.s27 { fill: url(#g19) } \n\t\t.s28 { fill: url(#g20) } \n\t\t.s29 { fill: url(#g21) } \n\t\t.s30 { fill: url(#g22) } \n\t\t.s31 { fill: url(#g23) } \n\t\t.s32 { fill: url(#g24) } \n\t\t.s33 { fill: url(#g25) } \n\t\t.s34 { fill: url(#g26) } \n\t\t.s35 { fill: url(#g27) } \n\t\t.s36 { opacity: .3;mix-blend-mode: multiply;fill: #c72781 } \n\t\t.s37 { opacity: .8;mix-blend-mode: multiply;fill: #ab2781 } \n\t\t.s38 { opacity: .4;mix-blend-mode: soft-light;fill: #ffffff } \n\t\t.s39 { opacity: .5;mix-blend-mode: multiply;fill: #d14894 } \n\t\t.s40 { opacity: .2;mix-blend-mode: multiply;fill: #c22781 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "objects"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m117.3 60.7c-2.9 8.8-3.9 26.2-3.9 26.2l30.3 14-6.3 60.4-22.7 87.2-21.6 2.2c0 0 0.1-7.1 1.8-10.1 1.6-2.9 8.4-11.4 8.8-14.2 0.3-2.7 0.5-16.6 2-18 1.5-1.5 2-6.8 2-12.7 0-5.9 3.7-10 4.6-12.9 0.9-2.8 0.4-9.7-0.6-10.8-1-1.1-16.3-3.7-24.5-11.6-10-9.7-8.5-21-8.5-22.1 0-1.1 6.4 1.1 14 4.7 7.6 3.6 23.2 9.9 23.2 9.9 0 0 5.7-3 4.9-3.5-0.9-0.5-23.2-5-29.2-20-6.1-15-4.4-35 1.5-49.4 2.9-7 14.7-11.7 14.7-11.7 7.9-18.1 16.5-20.8 16.5-20.8 0 0-4.2 4.3-7 13.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m106.6 121.4c-2.3-3.6-6.5-14.2-3.9-30.7 0.9-5.4 2.5-11.5 5.2-18.3 10.7-27.1 23.6-29.4 20-23.5q0 0 0 0.1c-11.9 19.7-24.9 52.3-22.9 58.3 1.9 6 2.3 5.4 2.3 5.4 2.3 3.9 0.5 11.1-0.7 8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m106.6 121.4c-2.3-3.6-6.5-14.2-3.9-30.7 0.4 4.4 2.2 4.3 9.4-12.9 7-16.4 15-27.8 15.8-28.8-11.9 19.7-24.9 52.3-22.9 58.3 1.9 6 2.3 5.4 2.3 5.4 2.3 3.9 0.5 11.1-0.7 8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m134.8 245.5c0 0 0.4 3.4 0.4 3.7 0 0.3-9.5 1.2-22.7 2.8-13.2 1.6-19.4-1.3-19.4-1.3l0.7-4c0 0 11.7 1 21.2 0.9 9.5-0.1 19.8-2.1 19.8-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m83 134.2c3.7 0.9 8.2 5.3 8.2 5.3-0.3-3.4 0.9-5 1.6-4.1 1.5 1.7 3.1 4.5 5 7 1.8 2.6 1.9 4.9 1.9 4.9q0.8 0.3 1.5 0.7 0 0 0 0c10.1 4.5 22.5 6.4 24.6 7.9l-8.1 15.7c0 0-0.8-1.2-14-5-3.3-1-6.3-2.2-9-3.7-8.3-4.5-13.9-11.2-15.3-17.6-1.8-8.4 0-12 3.6-11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m132 208.7c0.3 1.1 0 18.6 0.5 23.4 0.6 4.9 2.3 13.4 2.3 13.4 0 0-0.6 1-4.8 1.5-4.2 0.4-9.2 0.2-19.6 1.3-10.3 1-16.6-1.6-16.6-1.6 1.6-3.9 7.8-13.2 10-16.1 2.1-2.8 3.7-10.9 4.6-19.1 0.8-8.2 5.2-22.8 5.2-22.8 0 0 18.2 19 18.4 20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m143.4 153.3c1.9 0.9 3 26.2 4.3 34.1 1.4 8-12.5 24.3-18.6 24.1-6.1-0.3-15.9-12.7-15.5-25 0.4-12.4 7.9-26.9 10.7-30.2 2.9-3.2 16.4-4.2 19.1-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m95.7 79.7c1.2-2.3 3.5-4.7 6.9-6.9 7.1-4.8 18.8-8.6 34-8.2 22.2 0.4 45.9 16.6 50.7 34.5 2.4 9.3-0.8 20.5-5.5 29.9q0 0 0 0c-2.4 4.9-5.3 9.2-7.9 12.6q-0.1 0-0.1 0c-2 2.5-4 4.5-5.5 5.6-7.5 5.2-26.4 7-26.4 7q-0.7 0.2-1.3 0.4-0.1 0-0.1 0c-9.3 2.9-13.5-0.5-13.5-0.5-6.6-4.6-27.7-15.5-33.3-25.8q-0.4-0.8-0.7-1.6-0.3-0.7-0.5-1.4c-3.9-12.7-0.4-38.6 3.2-45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m167.5 142.1c6.2-3.1 13.8-12.5 14.3-13.1-2.4 4.9-5.3 9.2-7.9 12.6q-0.1 0-0.1 0c-2 2.5-4 4.5-5.5 5.6-7.5 5.2-26.4 7-26.4 7q-0.7 0.2-1.3 0.4c1.2-0.5 20.8-9.3 26.9-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m95.7 79.7c1.2-2.3 3.5-4.7 6.9-6.9 6.1-1.2 9.1 4.2 19.2 4.9 10.1 0.6 27.9-4.1 33.7-3.4 5.8 0.7 15.7 7.3 17.2 19.3 1.6 11.9-4.6 22.2-4.6 22.2l-68.7 12.2-6.9-2.7c-3.9-12.7-0.4-38.6 3.2-45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m99 78.2c5.1-4.7 7.9-2.8 9.5-2.1 2.2 1 5 6.9 16.6 6 11.5-0.8 23.5-7.4 32.4-5.7 8.9 1.8 16.4 14.9 14.5 27.5-0.9 5.9-3.7 12.3-7.3 17.8q0 0 0 0c-4.2 6.3-9.2 11.5-13.5 13.7-9.7 4.9-41.6 4.6-53.1-7.9q-1.1-1.3-2-2.7-1.1-1.8-1.9-3.9c-5.9-14.9-0.8-37.4 4.8-42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m139.4 144.6c16.3 0.7 29.7-2 34.4-3-2 2.5-4 4.5-5.5 5.6-7.5 5.2-26.4 7-26.4 7-10.3 3.6-14.9-0.1-14.9-0.1-6.6-4.6-27.7-15.5-33.3-25.8 9.7 11.5 23.7 15.3 45.7 16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m99 78.2c5.1-4.7 7.9-2.8 9.5-2.1 2.2 1 5 6.9 16.6 6 11.5-0.8 23.5-7.4 32.4-5.7 8.9 1.8 16.4 14.9 14.5 27.5-0.9 5.9-3.7 12.3-7.3 17.8 7.6-11.6-29.4-25.1-54.3-21.8-24.1 3.2-13 26.2-12.3 27.5l-3.9-6.5c-5.9-14.9-0.8-37.4 4.8-42.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m108.5 79.8c0.6-2.3 1.7-4.4 3-6 4.9-5.8 16.2-8.5 24.1-3.3q1.3 0.9 2.2 2.2c5.1 7.6-1.9 23.8-17.4 24.2-11.4 0.3-14.1-9.3-11.9-17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m114.4 79.4c0.3-1.2 0.8-2.4 1.5-3.4 2.4-3.4 8.5-5.7 12.9-3.1q0.8 0.5 1.3 1.2c3 4.4-1.5 14-9.8 14.2-5.6 0.1-6.9-4.8-5.9-8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m115.5 80.6c0.2-1.1 0.7-2 1.3-2.9 2.1-2.9 7.2-4.7 11-2.5q0.7 0.4 1.1 1.1c2.5 3.7-1.3 11.8-8.4 12-4.8 0.1-5.9-4.2-5-7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m108.5 79.8q0 0-0.1 0.1c-1.6 9.5 4.6 17 15.7 13.6 11.2-3.4 16.1-15.3 13.7-20.8 5.1 7.6-1.9 23.8-17.4 24.2-11.4 0.3-14.1-9.3-11.9-17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m152.7 137.5c1.2 0.5-4.1 6.6-13 6.3-8.9-0.2-9.3-2-9.1-3.2 0.1-1.1 19.9-3.9 22.1-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m154.5 111.8c4.6 2.7-1 15.3-10.9 14.2-9.8-1.1 1-20 10.9-14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m150.5 94.5c1.9 0.6-1.1 5.4-3.1 4.7-2-0.7 0-5.7 3.1-4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m128.7 86.5c2.1 0.1 0.8 3.9-2.5 3.6-3.2-0.2 0.6-3.7 2.5-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m113.4 86.9c1.2-0.1 0.5 2.1 0.1 2.1-0.4-0.1-2.3-2.1-0.1-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m94.7 128.8c0 0 0.2-1.2 4.1 0.9 3.9 2.1 8.6 8.1 7.1 7.5-7-2.5-11.2-8.4-11.2-8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m125.6 152.6c-8.5-3.2-18.8-14.1-18.8-14.1 0 0 3.3 1.2 12.8 3.9 9.4 2.7 14.6 0.9 19.3 3.6 4.8 2.8 2.5 5.5 1.3 6.8 0 0-6.1 3-14.6-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m155.7 79.9c-5.4-2.1-14.1-0.1-14.1-0.1 0 0 5.7-2.1 9.8-2 4 0.1 8.4 0.6 14.4 6.7 6.1 6.1 5.4 20.8 5.4 20.8-2.4-14.4-10.1-23.4-15.5-25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m94.1 91.6c0 0 0.1-4.2 4-9.2 3.8-4.9 8.8-4 8.8-4-6 1.6-12.8 13.2-12.8 13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m147.8 188.1c1.9 0.7 12.2 19.4 15.3 25.3 3.2 5.8 11.2 11.9 13.8 20.6 2.5 8.7 5 16.3 4.6 17.3-0.3 1.1-11.1 1.2-18 1.3-6.9 0-14.5-3-15-3.8-0.5-0.7-3.5-11.9-5.8-16.6-2.3-4.7-10.9-15.4-11.1-21.3-0.2-5.9 16.2-22.8 16.2-22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m145.2 155.8c3 0.4 9 6.1 13.7 13 3.6 5.2 10 11.5 15.4 17 1.7 1.7 3.4 3.4 4.8 4.9 5.9 6.2 8.6 15.2 8.2 16.5-0.5 1.4-4.8 2.2-9.8 0.8-4.6-1.4-6.5-2.9-6.7-3 0.2 0.2 1.3 1 2.1 2.1 0.8 1.1 0.7 2.6 0.2 3.3-0.5 0.7-3.3-1.3-6.2-3.4-2.9-2-3.1-5.1-4.6-8.5-0.2-0.6-0.9-1.6-1.9-2.8-4.8-5.9-16.5-18.1-18.7-24.2-2.6-7.3 3.5-15.7 3.5-15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m137.6 167.3q0.1-1.3 0.2-2.4 0-0.1 0-0.1 0-0.2 0-0.5c1.3-10.5 6.7-12.7 11.1-12.2 3 0.3 4.8 2.8 5.8 5.5 1.3 3.5 1.4 7.5 1.4 7.5l-4.5-5c0 0-3.2-2-5 6.9-1.9 8.8 1.2 13.9 1.2 13.9l2.3 2.8c0 0-12.1 2.3-12.5-13.4q0-1.6 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m116.1 155.8q1.1-1.5 2.2-2.3c4.5-3.3 8.7 0.5 8.7 0.5l0.8 0.6c-6.5 3.5-13.3 24.6-13.3 24.6 0 0-0.4-2-0.8-4.9-0.7-5.4-1-14 2.4-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m146.2 184.4q0.6 0 1.1 0.1c6.7 1.3 5.8 11.1 5.8 11.1l-2.9-4.7c0 0-4-0.5-10.8 7.9-6.7 8.4-6.3 17.2-6.3 17.2-0.2-0.1-1.8-1.3-3.1-4.1q0 0 0 0c-0.7-1.5-1.3-3.5-1.5-6-0.6-8 10.8-21.2 17.7-21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m113.6 186.5q0.1 1.8 0.4 3.5c1.7 10.7 7.9 16.7 12.1 19.6 2.1 1.6 3.8 2.2 3.9 2.3q0 0 0 0l0.6-0.4 2.5 4.5c-11.4 0.5-23.7-8.7-23.8-19.3-0.1-10.5 4.3-10.2 4.3-10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m174.3 185.8c1.7 1.7 3.4 3.4 4.8 4.9 5.9 6.2 8.6 15.2 8.2 16.5-0.5 1.4-4.8 2.2-9.8 0.8-4.6-1.4-6.5-2.9-6.7-3 0.2 0.2 1.3 1 2.1 2.1 0.8 1.1 0.7 2.6 0.2 3.3-0.5 0.7-3.5-1.1-6.2-3.4-4.7-3.9-3.1-5.1-4.6-8.5-0.2-0.6-0.9-1.6-1.9-2.8 1.7-9.6 13.9-9.9 13.9-9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m83 134.2c3.7 0.9 8.2 5.3 8.2 5.3-1-4.6 1.2-5.7 1.9-4.9 1.5 1.8 2.8 5.3 4.7 7.8 1.8 2.6 1.9 4.9 1.9 4.9q0.8 0.3 1.5 0.7c-0.2 0-10 3.5-6.5 14.9-8.3-4.5-13.9-11.2-15.3-17.6-1.8-8.4 0-12 3.6-11.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s28",
    d: "m121 172.5c-0.4 0-0.8-0.2-1.1-0.6-0.9-1.3-0.8-4.6 1.1-7.8 1.7-2.7 4.4-4.6 6-4.1 0.3 0.1 1 0.5 0.9 1.7-0.6 5.5-5 10.5-6.6 10.8q-0.1 0-0.3 0zm5.4-11.6c-1 0-3 1.3-4.5 3.7-1.8 2.9-1.8 5.8-1.2 6.7 0.1 0.2 0.3 0.2 0.4 0.2 1.2-0.2 5.3-4.8 5.8-9.9 0.1-0.6-0.2-0.7-0.2-0.7q-0.2 0-0.3 0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s29",
    d: "m182.1 251.9c-0.1 0.2-1.9 2.2-13.2 1.8-11.3-0.4-20.4-3.5-20.5-3.7 0-0.3-0.4-2.4-0.4-2.4 0 0 7.2 2.1 18.5 1.6 11.2-0.4 14.4-1.4 14.4-1.4 0 0 1.4 3.9 1.2 4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s30",
    d: "m133.9 240.9c0 0-14.7-11.8-29.6-11.1l0.6-1.4c0 0 11.2-2.3 29 12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s31",
    d: "m178.4 239.3c0 0-7.5-8-18.4-7.4-10.9 0.7-13.1 11.8-13.1 11.8 0 0 1-11.5 12.4-12.8 11.5-1.3 18 4.6 18 4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s32",
    d: "m146.7 229.9c-7.8 0.5-8.9-13-6.5-17.2 2.4-4.2 8.6-2.8 12.1 4.5 3.5 7.4-3.1 12.5-5.6 12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s33",
    d: "m142.8 227.2c-3.3-2.3-5.5-11.5-1.9-14.9 3.5-3.3 7.4 1.6 8.7 5.4 2.2 6-1.8 13.1-6.8 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s34",
    d: "m107.3 210.1c1.7-3.3 5.7 3.5 5.3 9.1-0.5 5.4-4.5 6.9-6.1 6.9-1.6 0-1.8-10.9 0.8-16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s35",
    d: "m107.7 209.5c1.4-0.7 4.4 5 3.8 9.3-0.6 4.4-4.1 6.6-5.2 6.3-1.2-0.3-1.2-5.4-1-8.9 0.3-3.5 1.7-6.4 2.4-6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m118.3 153.5c-6.6 4.4-5 16.1-5 16.1l-5.4-1.7c-6.1-14 8-15 8-15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m156.4 165.4c0 0-3-4-7-0.8-4.9 4.1-1.6 15.3-0.1 18.2 0 0-2-1.4-2.4-2.8-0.5-1.4-3.3-16.8 1.3-20.5 4.5-3.8 8.2 5.9 8.2 5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m137.8 164.8q0-0.3 0-0.5 0 0.3 0 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m137.6 167.3c0.1 5.1 2.2 12.7 5 10.7 3.3-2.4 1.4-10.6 3.7-16.5 2.3-5.7 8.1-4 8.4-3.9 1.3 3.5 1.4 7.5 1.4 7.5l-4.5-5c0 0-3.2-2-5 6.9-1.9 8.8 1.2 13.9 1.2 13.9l2.3 2.8c0 0-12.1 2.3-12.5-13.4q0-1.6 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m118.3 166.5c2.2-8.2 3.3-12.8 0-13 4.5-3.3 8.7 0.5 8.7 0.5l0.8 0.6c-6.5 3.5-13.3 24.6-13.3 24.6 0 0-0.4-2-0.8-4.9 0 0 2.4 0.5 4.6-7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m132.5 231.6c0 0-3.4 1.1-11.9-7-8.6-8.2-11.3-19.5-11.3-19.5l0.9-3.5c0 0 5 7.1 11.9 10.7 6.9 3.5 10.1 3.7 10.1 3.7 0 0 0 13.1 0.3 15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m154.4 197.8c0 0-2.6-4.7-11.2-1-8.6 3.7-8.8 19.4-6.9 25.1l-3.2-5.9c0 0-0.7-11.8 6.6-19.4 7.4-7.7 10.5-5.7 10.5-5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m113.6 186.5q0.1 1.8 0.4 3.5c-0.8-0.1-2.3 0.4-3.8 3.8-2.3 5.1 3.3 14.7 10.1 16.6 3.9 1.1 5.3 0.2 5.8-0.8 2.1 1.6 3.8 2.2 3.9 2.3-0.7-1.5-1.3-3.5-1.5-6 0 0 2.1 4.9 5.5-1.7 3.4-6.7 15.9-18.5 12.2-19.8q0.6 0 1.1 0.1c6.7 1.3 5.8 11.1 5.8 11.1l-2.9-4.7c0 0-4-0.5-10.8 7.9-6.7 8.4-6.3 17.2-6.3 17.2-11.4 0.5-23.7-8.7-23.8-19.3-0.1-10.5 4.3-10.2 4.3-10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s36",
    d: "m130 211.9c-13.2-5.3-15.3-18.5-15.3-18.5 0 0 9.3 11 12.7 6.5 3.4-4.5 9.3-9.9 9.3-9.9-10.8 10.6-6.7 21.9-6.7 21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m91.2 139.5c0 0 0.4 1.8-1.2 3.8-1.7 1.9 2.7 7 2.7 7 0 0-4.1-1.9-5.1-5.9-1.1-4 0.7-7.4 0.7-7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m92 149.9c0.4 2.1-5.9 4.8-9.2-1.4-3.2-6.3-2.6-10.7 0.9-11.2 3.5-0.6 7.1 3.7 7.1 4.2 0 0.6-0.9 1-1.1 2.3-0.3 1.3 2.3 6.1 2.3 6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s38",
    d: "m178.4 190.3c3.4 3.7 8.2 10.3 6.9 13.5-1.3 3.3-16.1-1.5-20.6-8-4.4-6.4 6.7-8.9 9.1-8.5 2.5 0.4 4.6 3 4.6 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m130.4 238.4c2.4 2.2-13.1 8.5-22.3 7.7-9.2-0.7-11.1-2.4-11.1-2.4 0 0 4.1-12.7 9.6-13 5.4-0.2 23.8 7.7 23.8 7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m177.3 238.6c1.6 1.5-4.5 9-12.8 9.3-8.2 0.3-13.8-3.3-14.6-5.4-0.8-2.1 1-9.2 10.6-10 9.6-0.7 16.8 6.1 16.8 6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m157.9 231.6c-9.7 1.9-10.7 11-10.7 11 0 0-1.4-11.7 9.4-13.4 10.8-1.6 18.4 4.7 18.4 4.7 0 0-7.5-4.2-17.1-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s39",
    d: "m104.9 228.4c0 0 3.1-3.6 11.8-0.2 8.6 3.4 14.9 11 14.9 11-13.8-11.4-26.7-10.8-26.7-10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m177.3 235.5c0 0-5.6-4.2-9.7-8.8-4.1-4.6-7.2-18.3-7.2-18.3 0 0 1.3 2.9 4.4 7.2 3.2 4.3 9.7 10.5 12.5 19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m122.2 240.2c-0.5-2.2-2.4-1-3.1 1-0.7 2 3.6 0.8 3.1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m156.1 245.5c0.7-0.5-0.9-3.6-3.6-2.9-2.7 0.7 2.1 3.9 3.6 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m133.9 180.6c2.1 2.3-0.3 6.1-3.3 5.2-3.1-1 1.9-6.8 3.3-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m147.2 183.7l0.1 0.8c0 0-3.7 0.3-7.1 2.4 0 0-1.6-1.9-2.4-6.6-0.8-4.6-0.1-8.3-0.1-8.3 0 0-0.3 8.8 9.5 11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m147.8 180.9c0 0 6.7 1.9 8.8 5.6 2.1 3.6 3.8 9.2 3.8 9.2-3.3-3.5-12.6-14.8-12.6-14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s37",
    d: "m172.6 206.7c-6.7-0.9-6.8-5-6.8-5 1.8 2 5.3 3.5 5.3 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m166.4 85c0 0-1.6 0.5-4-1.5-2.3-2.1-2.8-3.5-2.8-3.5 0 0 3.3 0.2 6.8 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m158.3 221.2c2.4 1.8-0.2 4.3-1.7 3.5-1.5-0.9-0.1-4.8 1.7-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m149.1 202.2c1.6 3.8-2.7 3.1-3.5 0.4-0.8-2.7 3-1.8 3.5-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m158.4 180.3c1.2 3.3-2.8 1.3-3.3 0-0.4-1.3 2.1-3.3 3.3 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m113.7 251.9c2.3-0.3 2.5-5.6 9.5-7.8 7-2.2 10.7 5.4 10.7 5.4 0 0-5.5-0.2-20.2 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s40",
    d: "m148.8 250.2c0 0-1.1-7.7 0-7.7 1.1 0 7.8 8.8 7.8 8.8 0 0-2.5 0.3-7.8-1.1z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImg1);
export default __webpack_public_path__ + "static/media/header-img1.f753f47ac892f77989d2666b5a193d86.svg";
export { ForwardRef as ReactComponent };